'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _Overlay = require('./Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var majorScale = _theme2.default.majorScale;


var rotate360InAnimation = _glamor.css.keyframes('rotate360InAnimation', {
  from: {
    transform: 'translateX(100%) rotate(0deg)'
  },
  to: {
    transform: 'translateX(-100%) rotate(-360deg)'
  }
});

var rotate360OutAnimation = _glamor.css.keyframes('rotate360OutAnimation', {
  from: {
    transform: 'translateX(-100%) rotate(0deg)'
  },
  to: {
    transform: 'translateX(100%) rotate(360deg)'
  }
});

var SheetClose = function SheetClose(_ref) {
  var isClosing = _ref.isClosing,
      props = _objectWithoutProperties(_ref, ['isClosing']);

  return _react2.default.createElement(
    _Box2.default,
    _extends({}, (0, _glamor.css)({
      cursor: 'pointer',
      transform: 'translateX(-100%)',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      transition: 'background-color ' + _theme2.default.animationDuration.fast,
      animation: (isClosing ? rotate360OutAnimation : rotate360InAnimation) + ' ' + _theme2.default.animationDuration.slow + ' ' + _theme2.default.animationEasing.deceleration,
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.6)'
      },
      '&:active': {
        backgroundColor: 'rgba(255, 255, 255, 0.4)'
      }
    }), props),
    _react2.default.createElement(_Close2.default, { fill: '#fff', display: 'block' })
  );
};

SheetClose.defaultProps = {
  position: 'absolute',
  marginLeft: majorScale(-2),
  marginTop: majorScale(2),
  padding: majorScale(1),
  circle: true
};

var slideInAnimation = _glamor.css.keyframes('slideInAnimation', {
  from: {
    transform: 'translateX(100%)'
  },
  to: {
    transform: 'translateX(0)'
  }
});

var slideOutAnimation = _glamor.css.keyframes('slideOutAnimation', {
  from: {
    transform: 'translateX(0)'
  },
  to: {
    transform: 'translateX(100%)'
  }
});

var SheetPane = function SheetPane(_ref2) {
  var slideOut = _ref2.slideOut,
      props = _objectWithoutProperties(_ref2, ['slideOut']);

  return _react2.default.createElement(_Pane2.default, _extends({}, (0, _glamor.css)({
    transform: 'translateZ(0)',
    animation: (slideOut ? slideOutAnimation : slideInAnimation) + ' ' + _theme2.default.animationDuration.slow + ' ' + _theme2.default.animationEasing.deceleration
  }), props));
};

SheetPane.propTypes = {
  slideOut: _propTypes2.default.bool
};

SheetPane.defaultProps = {
  white: true,
  position: 'absolute',
  shadow: true,
  top: 0,
  right: 0,
  bottom: 0
};

SheetPane.displayName = 'SheetPane';

var Sheet = function (_Component) {
  _inherits(Sheet, _Component);

  function Sheet() {
    _classCallCheck(this, Sheet);

    var _this = _possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call(this));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleFadeEnd = _this.handleFadeEnd.bind(_this);

    _this.state = {
      isClosing: false
    };
    return _this;
  }

  _createClass(Sheet, [{
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ isClosing: true });
    }
  }, {
    key: 'handleFadeEnd',
    value: function handleFadeEnd() {
      if (!this.state.isClosing) return;
      if (this.props.onClose) {
        this.props.onClose();
      }
      this.setState({ isClosing: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          children = _props.children;
      var isClosing = this.state.isClosing;


      if (!isOpen) return null;

      return _react2.default.createElement(
        _Overlay2.default,
        { onClick: this.handleClose, fadeOut: isClosing, onFadeEnd: this.handleFadeEnd },
        _react2.default.createElement(
          SheetPane,
          _extends({ slideOut: isClosing }, this.parseProps(this.props)),
          _react2.default.createElement(SheetClose, { isClosing: isClosing, onClick: this.handleClose }),
          children
        )
      );
    }
  }, {
    key: 'parseProps',
    value: function parseProps(_ref3) {
      var className = _ref3.className,
          children = _ref3.children,
          isOpen = _ref3.isOpen,
          onClose = _ref3.onClose,
          props = _objectWithoutProperties(_ref3, ['className', 'children', 'isOpen', 'onClose']);

      return props;
    }
  }]);

  return Sheet;
}(_react.Component);

Sheet.propTypes = _extends({}, _Box2.default.propTypes, {
  isOpen: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func
});

Sheet.defaultProps = {
  width: majorScale(85),
  isOpen: true
};

Sheet.displayName = 'Sheet';

exports.default = Sheet;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NoZWV0LmpzIl0sIm5hbWVzIjpbIm1ham9yU2NhbGUiLCJyb3RhdGUzNjBJbkFuaW1hdGlvbiIsImtleWZyYW1lcyIsImZyb20iLCJ0cmFuc2Zvcm0iLCJ0byIsInJvdGF0ZTM2ME91dEFuaW1hdGlvbiIsIlNoZWV0Q2xvc2UiLCJpc0Nsb3NpbmciLCJwcm9wcyIsImN1cnNvciIsImJhY2tncm91bmRDb2xvciIsInRyYW5zaXRpb24iLCJhbmltYXRpb25EdXJhdGlvbiIsImZhc3QiLCJhbmltYXRpb24iLCJzbG93IiwiYW5pbWF0aW9uRWFzaW5nIiwiZGVjZWxlcmF0aW9uIiwiZGVmYXVsdFByb3BzIiwicG9zaXRpb24iLCJtYXJnaW5MZWZ0IiwibWFyZ2luVG9wIiwicGFkZGluZyIsImNpcmNsZSIsInNsaWRlSW5BbmltYXRpb24iLCJzbGlkZU91dEFuaW1hdGlvbiIsIlNoZWV0UGFuZSIsInNsaWRlT3V0IiwicHJvcFR5cGVzIiwiYm9vbCIsIndoaXRlIiwic2hhZG93IiwidG9wIiwicmlnaHQiLCJib3R0b20iLCJkaXNwbGF5TmFtZSIsIlNoZWV0IiwiaGFuZGxlQ2xvc2UiLCJiaW5kIiwiaGFuZGxlRmFkZUVuZCIsInN0YXRlIiwic2V0U3RhdGUiLCJvbkNsb3NlIiwiaXNPcGVuIiwiY2hpbGRyZW4iLCJwYXJzZVByb3BzIiwiY2xhc3NOYW1lIiwiaXNSZXF1aXJlZCIsImZ1bmMiLCJ3aWR0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7OztJQUNRQSxVLG1CQUFBQSxVOzs7QUFFUixJQUFNQyx1QkFBdUIsWUFBSUMsU0FBSixDQUFjLHNCQUFkLEVBQXNDO0FBQ2pFQyxRQUFNO0FBQ0pDO0FBREksR0FEMkQ7QUFJakVDLE1BQUk7QUFDRkQ7QUFERTtBQUo2RCxDQUF0QyxDQUE3Qjs7QUFTQSxJQUFNRSx3QkFBd0IsWUFBSUosU0FBSixDQUFjLHVCQUFkLEVBQXVDO0FBQ25FQyxRQUFNO0FBQ0pDO0FBREksR0FENkQ7QUFJbkVDLE1BQUk7QUFDRkQ7QUFERTtBQUorRCxDQUF2QyxDQUE5Qjs7QUFTQSxJQUFNRyxhQUFhLFNBQWJBLFVBQWE7QUFBQSxNQUFHQyxTQUFILFFBQUdBLFNBQUg7QUFBQSxNQUFpQkMsS0FBakI7O0FBQUEsU0FDakI7QUFBQTtBQUFBLGlCQUFTLGlCQUFJO0FBQ1hDLGNBQVEsU0FERztBQUVYTixvQ0FGVztBQUdYTyxpREFIVztBQUlYQyx3Q0FBZ0MsZ0JBQU1DLGlCQUFOLENBQXdCQyxJQUo3QztBQUtYQyxrQkFBY1AsWUFBWUYscUJBQVosR0FBb0NMLG9CQUFsRCxVQUEwRSxnQkFBTVksaUJBQU4sQ0FBd0JHLElBQWxHLFNBQTBHLGdCQUFNQyxlQUFOLENBQXNCQyxZQUxySDtBQU1YLGlCQUFXO0FBQ1RQO0FBRFMsT0FOQTtBQVNYLGtCQUFZO0FBQ1ZBO0FBRFU7QUFURCxLQUFKLENBQVQsRUFZUUYsS0FaUjtBQWFFLHFEQUFPLE1BQUssTUFBWixFQUFtQixTQUFRLE9BQTNCO0FBYkYsR0FEaUI7QUFBQSxDQUFuQjs7QUFpQkFGLFdBQVdZLFlBQVgsR0FBMEI7QUFDeEJDLFlBQVUsVUFEYztBQUV4QkMsY0FBWXJCLFdBQVcsQ0FBQyxDQUFaLENBRlk7QUFHeEJzQixhQUFXdEIsV0FBVyxDQUFYLENBSGE7QUFJeEJ1QixXQUFTdkIsV0FBVyxDQUFYLENBSmU7QUFLeEJ3QixVQUFRO0FBTGdCLENBQTFCOztBQVFBLElBQU1DLG1CQUFtQixZQUFJdkIsU0FBSixDQUFjLGtCQUFkLEVBQWtDO0FBQ3pEQyxRQUFNO0FBQ0pDO0FBREksR0FEbUQ7QUFJekRDLE1BQUk7QUFDRkQ7QUFERTtBQUpxRCxDQUFsQyxDQUF6Qjs7QUFTQSxJQUFNc0Isb0JBQW9CLFlBQUl4QixTQUFKLENBQWMsbUJBQWQsRUFBbUM7QUFDM0RDLFFBQU07QUFDSkM7QUFESSxHQURxRDtBQUkzREMsTUFBSTtBQUNGRDtBQURFO0FBSnVELENBQW5DLENBQTFCOztBQVNBLElBQU11QixZQUFZLFNBQVpBLFNBQVk7QUFBQSxNQUFHQyxRQUFILFNBQUdBLFFBQUg7QUFBQSxNQUFnQm5CLEtBQWhCOztBQUFBLFNBQTRCLDJEQUFVLGlCQUFJO0FBQzFETCw4QkFEMEQ7QUFFMURXLGdCQUFjYSxXQUFXRixpQkFBWCxHQUErQkQsZ0JBQTdDLFVBQWlFLGdCQUFNWixpQkFBTixDQUF3QkcsSUFBekYsU0FBaUcsZ0JBQU1DLGVBQU4sQ0FBc0JDO0FBRjdELEdBQUosQ0FBVixFQUd0Q1QsS0FIc0MsRUFBNUI7QUFBQSxDQUFsQjs7QUFLQWtCLFVBQVVFLFNBQVYsR0FBc0I7QUFDcEJELFlBQVUsb0JBQVVFO0FBREEsQ0FBdEI7O0FBSUFILFVBQVVSLFlBQVYsR0FBeUI7QUFDdkJZLFNBQU8sSUFEZ0I7QUFFdkJYLFlBQVUsVUFGYTtBQUd2QlksVUFBUSxJQUhlO0FBSXZCQyxPQUFLLENBSmtCO0FBS3ZCQyxTQUFPLENBTGdCO0FBTXZCQyxVQUFRO0FBTmUsQ0FBekI7O0FBU0FSLFVBQVVTLFdBQVYsR0FBd0IsV0FBeEI7O0lBRU1DLEs7OztBQUNKLG1CQUFlO0FBQUE7O0FBQUE7O0FBR2IsVUFBS0MsV0FBTCxHQUFtQixNQUFLQSxXQUFMLENBQWlCQyxJQUFqQixPQUFuQjtBQUNBLFVBQUtDLGFBQUwsR0FBcUIsTUFBS0EsYUFBTCxDQUFtQkQsSUFBbkIsT0FBckI7O0FBRUEsVUFBS0UsS0FBTCxHQUFhO0FBQ1hqQyxpQkFBVztBQURBLEtBQWI7QUFOYTtBQVNkOzs7O2tDQUVjO0FBQ2IsV0FBS2tDLFFBQUwsQ0FBYyxFQUFFbEMsV0FBVyxJQUFiLEVBQWQ7QUFDRDs7O29DQUVnQjtBQUNmLFVBQUksQ0FBQyxLQUFLaUMsS0FBTCxDQUFXakMsU0FBaEIsRUFBMkI7QUFDM0IsVUFBSSxLQUFLQyxLQUFMLENBQVdrQyxPQUFmLEVBQXdCO0FBQUUsYUFBS2xDLEtBQUwsQ0FBV2tDLE9BQVg7QUFBc0I7QUFDaEQsV0FBS0QsUUFBTCxDQUFjLEVBQUVsQyxXQUFXLEtBQWIsRUFBZDtBQUNEOzs7NkJBRVM7QUFBQSxtQkFDcUIsS0FBS0MsS0FEMUI7QUFBQSxVQUNBbUMsTUFEQSxVQUNBQSxNQURBO0FBQUEsVUFDUUMsUUFEUixVQUNRQSxRQURSO0FBQUEsVUFFQXJDLFNBRkEsR0FFYyxLQUFLaUMsS0FGbkIsQ0FFQWpDLFNBRkE7OztBQUlSLFVBQUksQ0FBQ29DLE1BQUwsRUFBYSxPQUFPLElBQVA7O0FBRWIsYUFDRTtBQUFBO0FBQUEsVUFBUyxTQUFTLEtBQUtOLFdBQXZCLEVBQW9DLFNBQVM5QixTQUE3QyxFQUF3RCxXQUFXLEtBQUtnQyxhQUF4RTtBQUNFO0FBQUMsbUJBQUQ7QUFBQSxxQkFBVyxVQUFVaEMsU0FBckIsSUFBb0MsS0FBS3NDLFVBQUwsQ0FBZ0IsS0FBS3JDLEtBQXJCLENBQXBDO0FBQ0Usd0NBQUMsVUFBRCxJQUFZLFdBQVdELFNBQXZCLEVBQWtDLFNBQVMsS0FBSzhCLFdBQWhELEdBREY7QUFFR087QUFGSDtBQURGLE9BREY7QUFRRDs7O3NDQVFFO0FBQUEsVUFMREUsU0FLQyxTQUxEQSxTQUtDO0FBQUEsVUFKREYsUUFJQyxTQUpEQSxRQUlDO0FBQUEsVUFIREQsTUFHQyxTQUhEQSxNQUdDO0FBQUEsVUFGREQsT0FFQyxTQUZEQSxPQUVDO0FBQUEsVUFERWxDLEtBQ0Y7O0FBQUUsYUFBT0EsS0FBUDtBQUFjOzs7Ozs7QUFHckI0QixNQUFNUixTQUFOLGdCQUNLLGNBQUlBLFNBRFQ7QUFFRWUsVUFBUSxvQkFBVWQsSUFBVixDQUFla0IsVUFGekI7QUFHRUwsV0FBUyxvQkFBVU07QUFIckI7O0FBTUFaLE1BQU1sQixZQUFOLEdBQXFCO0FBQ25CK0IsU0FBT2xELFdBQVcsRUFBWCxDQURZO0FBRW5CNEMsVUFBUTtBQUZXLENBQXJCOztBQUtBUCxNQUFNRCxXQUFOLEdBQW9CLE9BQXBCOztrQkFFZUMsSyIsImZpbGUiOiJTaGVldC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCB7IGNzcyB9IGZyb20gJ2dsYW1vcidcbmltcG9ydCBCb3ggZnJvbSAnLi9Cb3gnXG5pbXBvcnQgUGFuZSBmcm9tICcuL1BhbmUnXG5pbXBvcnQgT3ZlcmxheSBmcm9tICcuL092ZXJsYXknXG5pbXBvcnQgQ2xvc2UgZnJvbSAnLi9DbG9zZSdcbmltcG9ydCB0aGVtZSBmcm9tICcuL3RoZW1lJ1xuY29uc3QgeyBtYWpvclNjYWxlIH0gPSB0aGVtZVxuXG5jb25zdCByb3RhdGUzNjBJbkFuaW1hdGlvbiA9IGNzcy5rZXlmcmFtZXMoJ3JvdGF0ZTM2MEluQW5pbWF0aW9uJywge1xuICBmcm9tOiB7XG4gICAgdHJhbnNmb3JtOiBgdHJhbnNsYXRlWCgxMDAlKSByb3RhdGUoMGRlZylgXG4gIH0sXG4gIHRvOiB7XG4gICAgdHJhbnNmb3JtOiBgdHJhbnNsYXRlWCgtMTAwJSkgcm90YXRlKC0zNjBkZWcpYFxuICB9XG59KVxuXG5jb25zdCByb3RhdGUzNjBPdXRBbmltYXRpb24gPSBjc3Mua2V5ZnJhbWVzKCdyb3RhdGUzNjBPdXRBbmltYXRpb24nLCB7XG4gIGZyb206IHtcbiAgICB0cmFuc2Zvcm06IGB0cmFuc2xhdGVYKC0xMDAlKSByb3RhdGUoMGRlZylgXG4gIH0sXG4gIHRvOiB7XG4gICAgdHJhbnNmb3JtOiBgdHJhbnNsYXRlWCgxMDAlKSByb3RhdGUoMzYwZGVnKWBcbiAgfVxufSlcblxuY29uc3QgU2hlZXRDbG9zZSA9ICh7IGlzQ2xvc2luZywgLi4ucHJvcHMgfSkgPT5cbiAgPEJveCB7Li4uY3NzKHtcbiAgICBjdXJzb3I6ICdwb2ludGVyJyxcbiAgICB0cmFuc2Zvcm06IGB0cmFuc2xhdGVYKC0xMDAlKWAsXG4gICAgYmFja2dyb3VuZENvbG9yOiBgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjQpYCxcbiAgICB0cmFuc2l0aW9uOiBgYmFja2dyb3VuZC1jb2xvciAke3RoZW1lLmFuaW1hdGlvbkR1cmF0aW9uLmZhc3R9YCxcbiAgICBhbmltYXRpb246IGAke2lzQ2xvc2luZyA/IHJvdGF0ZTM2ME91dEFuaW1hdGlvbiA6IHJvdGF0ZTM2MEluQW5pbWF0aW9ufSAke3RoZW1lLmFuaW1hdGlvbkR1cmF0aW9uLnNsb3d9ICR7dGhlbWUuYW5pbWF0aW9uRWFzaW5nLmRlY2VsZXJhdGlvbn1gLFxuICAgICcmOmhvdmVyJzoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiBgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjYpYFxuICAgIH0sXG4gICAgJyY6YWN0aXZlJzoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiBgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjQpYFxuICAgIH1cbiAgfSl9IHsuLi5wcm9wc30+XG4gICAgPENsb3NlIGZpbGw9JyNmZmYnIGRpc3BsYXk9J2Jsb2NrJyAvPlxuICA8L0JveD5cblxuU2hlZXRDbG9zZS5kZWZhdWx0UHJvcHMgPSB7XG4gIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICBtYXJnaW5MZWZ0OiBtYWpvclNjYWxlKC0yKSxcbiAgbWFyZ2luVG9wOiBtYWpvclNjYWxlKDIpLFxuICBwYWRkaW5nOiBtYWpvclNjYWxlKDEpLFxuICBjaXJjbGU6IHRydWVcbn1cblxuY29uc3Qgc2xpZGVJbkFuaW1hdGlvbiA9IGNzcy5rZXlmcmFtZXMoJ3NsaWRlSW5BbmltYXRpb24nLCB7XG4gIGZyb206IHtcbiAgICB0cmFuc2Zvcm06IGB0cmFuc2xhdGVYKDEwMCUpYFxuICB9LFxuICB0bzoge1xuICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZVgoMClgXG4gIH1cbn0pXG5cbmNvbnN0IHNsaWRlT3V0QW5pbWF0aW9uID0gY3NzLmtleWZyYW1lcygnc2xpZGVPdXRBbmltYXRpb24nLCB7XG4gIGZyb206IHtcbiAgICB0cmFuc2Zvcm06IGB0cmFuc2xhdGVYKDApYFxuICB9LFxuICB0bzoge1xuICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZVgoMTAwJSlgXG4gIH1cbn0pXG5cbmNvbnN0IFNoZWV0UGFuZSA9ICh7IHNsaWRlT3V0LCAuLi5wcm9wcyB9KSA9PiA8UGFuZSB7Li4uY3NzKHtcbiAgdHJhbnNmb3JtOiBgdHJhbnNsYXRlWigwKWAsXG4gIGFuaW1hdGlvbjogYCR7c2xpZGVPdXQgPyBzbGlkZU91dEFuaW1hdGlvbiA6IHNsaWRlSW5BbmltYXRpb259ICR7dGhlbWUuYW5pbWF0aW9uRHVyYXRpb24uc2xvd30gJHt0aGVtZS5hbmltYXRpb25FYXNpbmcuZGVjZWxlcmF0aW9ufWBcbn0pfSB7Li4ucHJvcHN9IC8+XG5cblNoZWV0UGFuZS5wcm9wVHlwZXMgPSB7XG4gIHNsaWRlT3V0OiBQcm9wVHlwZXMuYm9vbFxufVxuXG5TaGVldFBhbmUuZGVmYXVsdFByb3BzID0ge1xuICB3aGl0ZTogdHJ1ZSxcbiAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gIHNoYWRvdzogdHJ1ZSxcbiAgdG9wOiAwLFxuICByaWdodDogMCxcbiAgYm90dG9tOiAwXG59XG5cblNoZWV0UGFuZS5kaXNwbGF5TmFtZSA9ICdTaGVldFBhbmUnXG5cbmNsYXNzIFNoZWV0IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgY29uc3RydWN0b3IgKCkge1xuICAgIHN1cGVyKClcblxuICAgIHRoaXMuaGFuZGxlQ2xvc2UgPSB0aGlzLmhhbmRsZUNsb3NlLmJpbmQodGhpcylcbiAgICB0aGlzLmhhbmRsZUZhZGVFbmQgPSB0aGlzLmhhbmRsZUZhZGVFbmQuYmluZCh0aGlzKVxuXG4gICAgdGhpcy5zdGF0ZSA9IHtcbiAgICAgIGlzQ2xvc2luZzogZmFsc2VcbiAgICB9XG4gIH1cblxuICBoYW5kbGVDbG9zZSAoKSB7XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGlzQ2xvc2luZzogdHJ1ZSB9KVxuICB9XG5cbiAgaGFuZGxlRmFkZUVuZCAoKSB7XG4gICAgaWYgKCF0aGlzLnN0YXRlLmlzQ2xvc2luZykgcmV0dXJuXG4gICAgaWYgKHRoaXMucHJvcHMub25DbG9zZSkgeyB0aGlzLnByb3BzLm9uQ2xvc2UoKSB9XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGlzQ2xvc2luZzogZmFsc2UgfSlcbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3QgeyBpc09wZW4sIGNoaWxkcmVuIH0gPSB0aGlzLnByb3BzXG4gICAgY29uc3QgeyBpc0Nsb3NpbmcgfSA9IHRoaXMuc3RhdGVcblxuICAgIGlmICghaXNPcGVuKSByZXR1cm4gbnVsbFxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxPdmVybGF5IG9uQ2xpY2s9e3RoaXMuaGFuZGxlQ2xvc2V9IGZhZGVPdXQ9e2lzQ2xvc2luZ30gb25GYWRlRW5kPXt0aGlzLmhhbmRsZUZhZGVFbmR9PlxuICAgICAgICA8U2hlZXRQYW5lIHNsaWRlT3V0PXtpc0Nsb3Npbmd9IHsuLi50aGlzLnBhcnNlUHJvcHModGhpcy5wcm9wcyl9PlxuICAgICAgICAgIDxTaGVldENsb3NlIGlzQ2xvc2luZz17aXNDbG9zaW5nfSBvbkNsaWNrPXt0aGlzLmhhbmRsZUNsb3NlfSAvPlxuICAgICAgICAgIHtjaGlsZHJlbn1cbiAgICAgICAgPC9TaGVldFBhbmU+XG4gICAgICA8L092ZXJsYXk+XG4gICAgKVxuICB9XG5cbiAgcGFyc2VQcm9wcyAoe1xuICAgIGNsYXNzTmFtZSxcbiAgICBjaGlsZHJlbixcbiAgICBpc09wZW4sXG4gICAgb25DbG9zZSxcbiAgICAuLi5wcm9wc1xuICB9KSB7IHJldHVybiBwcm9wcyB9XG59XG5cblNoZWV0LnByb3BUeXBlcyA9IHtcbiAgLi4uQm94LnByb3BUeXBlcyxcbiAgaXNPcGVuOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICBvbkNsb3NlOiBQcm9wVHlwZXMuZnVuY1xufVxuXG5TaGVldC5kZWZhdWx0UHJvcHMgPSB7XG4gIHdpZHRoOiBtYWpvclNjYWxlKDg1KSxcbiAgaXNPcGVuOiB0cnVlXG59XG5cblNoZWV0LmRpc3BsYXlOYW1lID0gJ1NoZWV0J1xuXG5leHBvcnQgZGVmYXVsdCBTaGVldFxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Sheet.js
// module id = 1132
// module chunks = 0